import { 
    FETCH_CORPORATE_EARNING,
    FETCH_CORPORATE_EARNING_SUCCESS,
    FETCH_CORPORATE_EARNING_FAILED,
  } from "../store/types";
  
  export const INITIAL_STATE = {
    corporatearnings:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const corporateearningreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_CORPORATE_EARNING:
        return {
          ...state,
          loading:true
        };
      case FETCH_CORPORATE_EARNING_SUCCESS:
        return {
          ...state,
          corporatearnings:action.payload,
          loading:false
        };
      case FETCH_CORPORATE_EARNING_FAILED:
        return {
          ...state,
          corporatearnings:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
        default:
        return state;
    
    }
  };